<template>
  <div class="">
    <page-header
      title="Scheduled Shipments"
      breadcrumb="Dashboard >> Scheduled Shipments"
    />
    <div class="custom-card">
      <div class="group-options-select">
        <div class="flex">
          <div
            class="mr-2 p-2 px-3 filter cursor-pointer hover:shadow-sm"
            :class="{ 'shadow-sm': sortList }"
            @click="sortList = !sortList"
          >
            <img src="@/assets/images/icons/filter.svg" alt="filter icon" />
          </div>

          <div class="table__search-input-wrapper">
            <span class="pr-2 opacity-50"><search-icon /> </span>
            <input
              type="text"
              class="table__search-input"
              placeholder="Search..."
              v-model="queryString"
            />
            <img src="@/assets/images/icons/search.svg" alt="search icon" />
          </div>
        </div>
      </div>
      <fleets-table :bookings="bookings" />
    </div>
  </div>
</template>

<script>
import FleetsTable from "./BookingsTable";
import PageHeader from "@/components/UI/NewPageHeader";

export default {
  components: {
    FleetsTable,
    PageHeader,
  },
  data() {
    return {
      bookings: [],
      queryString: "",
    };
  },
  mounted() {
    this.getScheduledShippings();
  },
  methods: {
    async getScheduledShippings() {
      try {
        const response = await this.$_getScheduledShippings();
        this.log(response);
        this.bookings = response.data.data.shippings;
      } catch (error) {
        this.handleError(error);
      }
    },
  },
};
</script>

<style></style>
